<template>
	<div>
    <div v-if="$root.source != 'galbani'">
      <label class="conditions" name="conditions">
        <input name="conditions" type="checkbox"
          v-model="state"
          v-on:change="onChange"
        >

        Iscrivendoti e creando un account, dichiari di essere maggiorenne ed aver preso visione e accettato integralmente le
        <router-link
          :to="{name: 'legal'}"
          target='_blank'
          class="link-detail"
          :title="$t('auth.checkbox.general_conditions')"
          v-html="`Condizioni generali di vendita`"
        />
        e la
        <router-link
          :to="{name: 'privacy-policy'}"
          class="link-detail"
          :title="$t('auth.checkbox.privacy')"
          target='_blank'
          v-html="`Privacy policy`"
        />
        <span class="tag-partner"> di Quomi</span> e sarai iscritto alla newsletter di Quomi.
      </label>
    </div>

    <div v-else>
  		<label class="conditions" name="conditions">
  			<input name="conditions" type="checkbox"
  				v-model="state"
  				v-on:change="onChange"
  			>

  			<template v-if="type === 'general'">

  				<span v-html="$t('components.checkbox.conditions')"></span>
  			</template>

  			<template v-if="type === 'signup'">
  				Acconsento all’uso dei miei dati personali per ricevere promozioni esclusive e proposte personalizzate
  			</template>

  			<slot name="label" />

  		</label>

      <label class="conditions" name="conditions">

      
        Iscrivendoti e creando un account, dichiari di essere maggiorenne ed aver preso visione e accettato integralmente le
        <router-link
          :to="{name: 'legal'}"
          target='_blank'
          class="link-detail"
          :title="$t('auth.checkbox.general_conditions')"
          v-html="`Condizioni generali di vendita`"
        />
        e la
        <router-link
          :to="{name: 'privacy-policy'}"
          class="link-detail"
          :title="$t('auth.checkbox.privacy')"
          target='_blank'
          v-html="`Privacy policy`"
        />
        <span class="tag-partner"> di Quomi</span>.  


      </label>
    </div>
	</div>
</template>

<script>

export default {

	data () {
		return {
			state: false
		}
	},

	props: {
		type: {
			type: String,
			default: null
		}
	},

	methods: {
		onChange () {
			this.$emit('checkboxEvent', this.state)
		}
	},

	mounted () {
		this.onChange()
	}

}

</script>

<style scoped>

	label {
		margin: 10px 0 5px 0;
		font-size: 13px;
		cursor: pointer;
	}

	input {
		cursor: pointer;
		width: 20px;
		vertical-align: middle;
		margin-bottom: 1px;
		transform: scale(1.4);
   }

</style>
